import { render, staticRenderFns } from "./headerSpaceInfo.vue?vue&type=template&id=d4bf65c0&scoped=true"
import script from "./headerSpaceInfo.vue?vue&type=script&lang=js"
export * from "./headerSpaceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bf65c0",
  null
  
)

export default component.exports